/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rd_Score_Out_OfInputs */

const en_rd_score_out_of = /** @type {(inputs: Rd_Score_Out_OfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`out of 100`)
};

const id_rd_score_out_of = /** @type {(inputs: Rd_Score_Out_OfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`dari 100`)
};

/**
* | output |
* | --- |
* | "out of 100" |
*
* @param {Rd_Score_Out_OfInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const rd_score_out_of = /** @type {((inputs?: Rd_Score_Out_OfInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rd_Score_Out_OfInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_rd_score_out_of(inputs)
	return en_rd_score_out_of(inputs)
});